import * as React from 'react';
import * as style from './style.css';
import { IImage } from '../../types/layouts/image';
import { Image, UIHeading5 } from '@cian/ui-kit';
import { trackCardJkLinkClick } from '../../utils/tracking/trackCardJkLinkClick';

interface IGalleryProps {
  images: IImage[];
  url: string;
}

export const Gallery = ({ images, url }: IGalleryProps) => {
  const mainImage = React.useMemo(() => {
    return images.find(image => image.isDefault) || images[0];
  }, [images]);

  const restImages = React.useMemo(() => {
    return images.filter(image => !image.isDefault).slice(0, 3);
  }, [images]);

  return (
    <a className={style['gallery']} href={url} target="_blank" rel="noreferrer" onClick={trackCardJkLinkClick}>
      <div className={style['main-image']}>
        <Image src={mainImage.url} alt="" preloader={false} loading="lazy" borderRadius="4px" objectFit="contain" />
      </div>
      <div className={style['rest-images']}>
        {restImages.map((image, index) => (
          <div className={style['rest-image']} key={index}>
            <Image src={image.url} alt="" preloader={false} loading="lazy" borderRadius="4px" objectFit="cover" />
            {index === restImages.length - 1 && (
              <div className={style['overlay']}>
                <UIHeading5 color="text-inverted-default">Ещё фото</UIHeading5>
              </div>
            )}
          </div>
        ))}
      </div>
    </a>
  );
};
